import React, {useState, useEffect, useRef} from 'react';
import styled from "styled-components";
import {storeInvestment} from "@models/applicant";
import {getCityById} from "@models/district";
import {districtsSelection} from "@hooks/districts";
import Selection from "@molecules/selection/selection";
import {Container as SelectionDropdown} from "@molecules/selection/components/dropdown";
import {Header as SelectionDropdownHeader} from "@molecules/selection/components/dropdwon.header";
import CircleLoading from "@molecules/lotties/circle_loading";
import Captcha from "@molecules/auth/captcha";
import {isEmpty} from "@helpers/helpers";
import Input from "@atoms/input";
import ButtonBase from "@atoms/button.base";
import StatusGit from "@atoms/status_gif";
import {handleFormatNumbers, shortMoneyNumber} from "@helpers/numbers";
import {str_replace} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import {UpdateSelectionOptions} from "@hooks/selection.options";
import {handleSubmitInvestmentTrack} from "./investment_tracks";
import {showDealTypeByCity, showDistrictsInInvestmentForm} from "./helpers";
import RadioListGroup, {RadioBox, RadioLabel} from "../../../atoms/radio.list.group";
import PerfectScrollbar from 'react-perfect-scrollbar'
import {saveCookie} from "../../../../helpers/cookie";
import {toEnglishNumber} from "../../../helpers/numbers";
import {getInvestmentMinPriceByDistrict} from "../crm_requests/helpers";
import PinIcon from '@icons/pin.svg';
import {useWindowSize} from "../../../helpers/windows.size";
import {getTypesOptions} from "../../../hooks/types";

var fieldsInitialState = (city_id) => {
    return {
        invest_deal_type: {value: 'sale', error: '', visibility: true},
        district_id: {value: [], error: '', visibility: (Number(city_id) !== 262), loading: false},
        invest_types: {value: null, error: '', visibility: true, loading: false},
        price: {value: '', error: '', visibility: true},
        rent: {value: '', error: '', visibility: false},
        mortgage: {value: '', error: '', visibility: false},
        mobile: {value: '', error: '', visibility: true},
        captcha: {value: '', error: '', visibility: true},
    }
};

var defaultDealTypes = [
    {value: 'sale', label: 'خرید', checked: true},
    {value: 'rent', label: 'اجاره', checked: false},
];

const InvestmentForm = ({show, city_id, isBadeSaba = false, event_section, event_view, event_position, is_popup = false, citiesSelectionOptions = null, selectedDistrict, setSelectedCityId}) => {
    const windowSize = useWindowSize();
    const submitRef = useRef('');
    const [scrollEl, setScrollEl] = useState('');
    const [city, setCity] = useState(null);
    const [districts, setDistrictsItems] = useState({options: [], selected_items: []});
    const [propertyTypes, setPropertyTypes] = useState({options: [], selected_items: []});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [result, setResult] = useState({});
    const [captcha, setCaptcha] = useState({});
    const [fields, setFields] = useState(fieldsInitialState(city_id));
    const [moneyUnit, setMoneyUnit] = useState({});
    const [dealTypes, setDealTypes] = useState(defaultDealTypes);

    //console.log(city_id)
    useEffect(() => {
        setFields(fieldsInitialState((!isEmpty(city) ? city.id : city_id)));

        setResult({text: '', status: ''});

        setCaptcha({token: '', error: ''});

        setMoneyUnit({});

        setDealTypes([
            {value: 'sale', label: 'خرید', checked: true},
            {value: 'rent', label: 'اجاره', checked: false},
        ])

    }, [show]);

    useEffect(() => {

        getCity((!isEmpty(city) ? city.id : city_id));

        getDistrictsSelectionOption((!isEmpty(city) ? city.id : city_id));

        getPropertyTypesSelectionOption((!isEmpty(city) ? city.id : city_id))
    }, [city_id, show]);

    const getCity = (id) => {
        getCityById(id).then(city => {
            setCity(city)
        }).catch(err => {
            setTimeout(() => {
                getCity(id);
            }, 1000)
        });
    };

    const getDistrictsSelectionOption = (cityId) => {
        if (!isEmpty(cityId) && showDistrictsInInvestmentForm(cityId)) {
            districtsSelection(cityId).then(result => {

                if (!isEmpty(selectedDistrict)) {
                    for (let option of result.options) {
                        if (Number(option.value) === Number(selectedDistrict)) {
                            option['checked'] = true
                        }
                    }

                    result.selected_items.push(selectedDistrict);

                    setFields(state => ({
                        ...state,
                        ['district_id']: {value: [selectedDistrict], error: '', visibility: true, loading: false},
                    }));
                } else {
                    setFields(state => ({
                        ...state,
                        ['district_id']: {value: [], error: '', visibility: true, loading: false},
                    }));
                }

                setDistrictsItems(result);
            });

        } else if (!showDistrictsInInvestmentForm(cityId)) {
            setFields(state => ({
                ...state,
                ['district_id']: {value: [], error: '', visibility: false, loading: false},
            }));
        }
    };

    const getPropertyTypesSelectionOption = (cityId) => {
        if (!isEmpty(cityId)) {
            getTypesOptions(cityId).then(result => {
                setPropertyTypes(result);

                setFields(state => ({
                    ...state,
                    ['invest_types']: {value: null, error: '', visibility: true, loading: false},
                }));
            });

        }
    };

    const handleChange = (e) => {
        let value = e.target.value;
        const name = e.target.name;

        value = str_replace(' ', '', value);
        value = toEnglishNumber(value);

        setFields(state => ({
            ...state,
            [name]: {value: str_replace(',', '', value), error: '', visibility: true, loading: false},
        }));

        if (name === 'invest_deal_type') {
            let newDealTypes = [...dealTypes];
            for (let item of newDealTypes) {
                item['checked'] = (item.value === value);
            }

            setDealTypes(newDealTypes);
            setMoneyUnit({});

            if (value === 'sale') {
                setFields(state => ({
                    ...state,
                    ['price']: {value: '', error: '', visibility: true},
                    ['rent']: {value: '', error: '', visibility: false},
                    ['mortgage']: {value: '', error: '', visibility: false},
                }));
            } else {
                setFields(state => ({
                    ...state,
                    ['price']: {value: '', error: '', visibility: false},
                    ['rent']: {value: '', error: '', visibility: true},
                    ['mortgage']: {value: '', error: '', visibility: true},
                }));
            }
        }

        if (inArray(name, ['price', 'rent', 'mortgage'])) {
            const money = shortMoneyNumber(str_replace(',', '', value));

            let setMoney = moneyUnit;
            if (name === 'price') {
                setMoney = {};
            } else {
                delete setMoney['price'];
            }

            setMoney[name] = money.num + ' ' + money.unit;

            setMoneyUnit(setMoney);
        }
    };

    const handleCityChange = (data) => {
        if (!isEmpty(data.items)) {
            const id = data.items[0];
            getCity(id);

            setSelectedCityId(id);

            setDealTypes(defaultDealTypes);

            setFields(state => ({
                ...state,
                ['invest_deal_type']: {value: 'sale', error: '', visibility: true},
                ['price']: {value: '', error: '', visibility: true},
                ['rent']: {value: '', error: '', visibility: false},
                ['mortgage']: {value: '', error: '', visibility: false},
                ['district_id']: {value: [], error: '', visibility: true, loading: true},
                ['invest_types']: {value: null, error: '', visibility: true, loading: true},
            }));

            getDistrictsSelectionOption(id);
            getPropertyTypesSelectionOption(id)
        }
    };

    const handleDistrictChange = (data) => {
        const districtsItems = JSON.parse(JSON.stringify(districts));

        if (!isEmpty(data.items)) {
            const district_ids = data.items;

            const newDistrict = UpdateSelectionOptions(districtsItems.options, data);
            setDistrictsItems(newDistrict);

            setFields(state => ({
                ...state,
                ['district_id']: {value: district_ids, error: '', visibility: true, loading: false},
            }));
        }
    };

    const handleChangeProductTypes = (data) => {
        const typesItems = JSON.parse(JSON.stringify(propertyTypes));

        if (!isEmpty(data.items)) {
            const type = data.items[0];

            const newPropertyTypes = UpdateSelectionOptions(typesItems.options, data);
            setPropertyTypes(newPropertyTypes);

            setFields(state => ({
                ...state,
                ['invest_types']: {value: type, error: '', visibility: true, loading: false},
            }));
        }
    };

    const submitInvest = () => {
        const items = {...fields};
        let hasError = false;
        const minPrice = getInvestmentMinPriceByDistrict((!isEmpty(city) ? city.id : city_id), fields.district_id.value);
        const shortPrice = shortMoneyNumber(minPrice);

        Object.keys(items).forEach(key => {
            items[key]['error'] = '';
        });

        if (items.invest_deal_type.value === 'sale' && isEmpty(items.price.value)) {
            items['price']['error'] = 'بودجه رو وارد کنید.';
            hasError = true;
        } else if (items.invest_deal_type.value === 'sale' && !isEmpty(items.price.value) && Number(items.price.value) < minPrice) {
            items['price']['error'] = `حداقل بودجه ثبت درخواست در این منطقه، ${shortPrice.num} ${shortPrice.unit} است.`;
            hasError = true;
        } else if (items.invest_deal_type.value === 'rent' && (isEmpty(items.rent.value) || isEmpty(items.mortgage.value))) {
            items['rent']['error'] = 'مبلغ اجاره رو وارد کنید.';
            items['mortgage']['error'] = 'مبلغ رهن رو وارد کنید.';
            hasError = true;
        }

        if (isEmpty(items.mobile.value)) {
            items['mobile']['error'] = 'موبایل‌تون رو وارد کنید.';
            hasError = true;
        }

        if (!items.invest_types.value) {
            items['invest_types']['error'] = 'نوع ملک رو انتخاب کنید.';
            hasError = true;
        }

        if (hasError) {
            if (!isEmpty(scrollEl)) {
                scrollEl.scrollTop = scrollEl.scrollHeight + 50;
            }

            setFields(items);
        } else {
            setSubmitLoading(true);

            const investData = {
                mobile: fields.mobile.value,
                city_id: (!isEmpty(city) ? city.id : city_id),
                district_id: fields.district_id.value,
                deal_type: fields.invest_deal_type.value,
                type: fields.invest_types.value,
                price: fields.price.value,
                rent: fields.rent.value,
                mortgage: fields.mortgage.value,
                captcha_code: fields.captcha.value,
                source: (isBadeSaba ? 'badesaba' : '2nabsh'),
            };

            storeInvestment(investData).then(result => {
                setResult({
                    text: 'درخواست شما با موفقیت ثبت شد! <br/> کارشناس‌های ۲نبش نهایتا تا یک روز کاری دیگه با شما تماس خواهند گرفت.',
                    status: 'done',
                });

                setSubmitLoading(false);
                handleSubmitInvestmentTrack((!isEmpty(city) ? city.id : city_id), event_section, event_view, event_position);
                saveCookie('show_investment_popup', true); // 30 day
                saveCookie('investment_submitted', true); // 30 day
            }).catch(error => {
                setSubmitLoading(false);
                hasError = false;

                if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
                    const response = error.response.data;

                    if (!isEmpty(response) && !isEmpty(response.captcha_token)) {
                        setCaptcha({token: response.captcha_token, error: ''});
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.price)) {
                        items['price']['error'] = 'قیمت رو کمتر از 10 میلیون وارد کردید.';
                        hasError = true;
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.mortgage)) {
                        items['mortgage']['error'] = 'مبلغ رهن رو وارد کنید.';
                        hasError = true;
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.rent)) {
                        items['rent']['error'] = 'مبلغ اجاره رو وارد کنید.';
                        hasError = true;
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.mobile)) {
                        items['mobile']['error'] = 'موبایل‌تون رو اشتباه وارد کردید.';
                        hasError = true;
                    }

                    if (!isEmpty(scrollEl)) {
                        scrollEl.scrollTop = scrollEl.scrollHeight + 50;
                    }

                    if (hasError) {
                        setFields(items);
                    }
                } else {
                    setResult({
                        text: 'انگار خطایی رخ داد لطفا دوباره تلاش کنید.',
                        status: 'cancel',
                    });
                }
            });
        }
    };

    return (
        <div className="invest-form-container text-center mt-8 mt-lg-0 pb-24 pb-lg-0">
            <h3 className="h2 invest-form-title">
                {
                    (is_popup) ?
                        <span>موردی پیدا نکردید؟</span>
                        :
                        <span>درخواست ملک {!isEmpty(city) ? ' در ' + city.name : ''}</span>
                }
            </h3>

            <PerfectScrollbar containerRef={(ref) => {
                setScrollEl(ref);
            }}>
                <Body className={"invest-form-body text-right px-24 px-lg-32 pb-md-0 " + (isEmpty(result.status) ? ' pt-24' : ' text-center')}>

                    {
                        (isEmpty(result.status)) ?
                            <React.Fragment>
                                {
                                    (is_popup) ?
                                        <p className="text-center mb-24 invest-form-hint">مشخصات ملک مورد نظرتون رو ثبت کنید تا هیچ ملک جدیدی رو از دست ندید.</p>
                                        :
                                        <p className="text-center mb-24 invest-form-hint">کارشناس‌های ۲نبش با همکاری شبکه‌ای از دفاتر املاک معتبر، درخواست شما رو پیگیری می‌کنند.</p>
                                }

                                {
                                    (!isEmpty(citiesSelectionOptions) && citiesSelectionOptions.length) ?
                                        <SelectionBox className={"mb-24 "}>
                                            <Selection
                                                type="single"
                                                name="city_id"
                                                options={citiesSelectionOptions}
                                                searchable
                                                limit_select={10}
                                                selected_items={(!isEmpty(city) ? [city.id] : [city_id])}
                                                label="شهر"
                                                onChange={(data) => handleCityChange(data)}
                                                scroll_lock={(windowSize > 0 && windowSize < 769)}
                                                icon={<PinIcon/>}
                                                clearabel={false}
                                            />
                                        </SelectionBox>
                                        : ''
                                }

                                {
                                    (!isEmpty(city) && showDealTypeByCity(city.id)) ?
                                        <div className="d-flex align-items-center">
                                            {
                                                dealTypes.map((item, key) =>
                                                    <RadioListGroup
                                                        name="invest_deal_type"
                                                        key={key}
                                                        item={item}
                                                        onChange={handleChange}/>
                                                )
                                            }
                                        </div>
                                        : ''
                                }

                                {
                                    (districts.options.length > 0 && showDistrictsInInvestmentForm((!isEmpty(city) ? city.id : city_id))) ?
                                        <SelectionBox className={"mt-24 " + (!fields.district_id.visibility ? 'd-none' : '')}>
                                            <Selection
                                                type="multiple"
                                                name="district_id"
                                                options={districts.options}
                                                searchable
                                                limit_select={10}
                                                selected_items={districts.selected_items}
                                                caption_show={2}
                                                label="خیابان"
                                                onChange={(data) => handleDistrictChange(data)}
                                                showLabelAndSelected={false}
                                                scroll_lock={(windowSize > 0 && windowSize < 769)}
                                                showSelectedItemsInTop={true}
                                                loading={fields.district_id.loading}
                                                clearabel={false}
                                            />
                                        </SelectionBox>
                                        :
                                        <SelectionBox className={"mt-24 " + (!fields.district_id.visibility ? 'd-none' : '')}>
                                            <Selection
                                                type="multiple"
                                                name="district"
                                                options={districts.options}
                                                selected_items={districts.selected_items}
                                                onChange={(data) => console.log(data)}
                                                label="خیابان"
                                            />
                                        </SelectionBox>
                                }

                                {
                                    (propertyTypes.options && propertyTypes.options.length) ?
                                        <SelectionBox className={"mt-24 "}>
                                            <Selection
                                                type="single"
                                                name="type"
                                                options={propertyTypes.options}
                                                searchable
                                                selected_items={propertyTypes.selected_items}
                                                caption_show={2}
                                                label="نوع ملک"
                                                onChange={(data) => handleChangeProductTypes(data)}
                                                showLabelAndSelected={false}
                                                scroll_lock={(windowSize > 0 && windowSize < 769)}
                                                showSelectedItemsInTop={true}
                                                loading={fields.district_id.loading}
                                                clearabel={false}
                                            />
                                            {
                                                (fields.invest_types.error) ?
                                                    <div className="invalid-feedback d-block">{fields.invest_types.error}</div>
                                                    : ''
                                            }
                                        </SelectionBox>
                                        : ''
                                }

                                <Input type="tel"
                                       labelPositionLeft={!isEmpty(fields.price.value) ? 'بودجه' : ''}
                                       name="price"
                                       onChange={handleChange}
                                       value={!isEmpty(fields.price.value) ? handleFormatNumbers(fields.price.value) : ''}
                                       autoCompleteOff={true}
                                       className={"mt-24 " + (!fields.price.visibility ? 'd-none' : '')}
                                       isInvalid={(!isEmpty(fields.price.error))}
                                       invalidFeedback={fields.price.error}
                                       placeholder="بودجه شما"/>

                                <Input type="tel"
                                       name="mortgage"
                                       labelPositionLeft={!isEmpty(fields.mortgage.value) ? 'رهن' : ''}
                                       onChange={handleChange}
                                       value={!isEmpty(fields.mortgage.value) ? handleFormatNumbers(fields.mortgage.value) : ''}
                                       autoCompleteOff={true}
                                       className={"mt-24 " + (!fields.mortgage.visibility ? 'd-none' : '')}
                                       isInvalid={(!isEmpty(fields.mortgage.error))}
                                       invalidFeedback={fields.mortgage.error}
                                       placeholder="حداکثر بودجه رهن"/>

                                <Input type="tel"
                                       name="rent"
                                       labelPositionLeft={!isEmpty(fields.rent.value) ? 'اجاره' : ''}
                                       onChange={handleChange}
                                       value={!isEmpty(fields.rent.value) ? handleFormatNumbers(fields.rent.value) : ''}
                                       autoCompleteOff={true}
                                       className={"mt-24 " + (!fields.rent.visibility ? 'd-none' : '')}
                                       isInvalid={(!isEmpty(fields.rent.error))}
                                       invalidFeedback={fields.rent.error}
                                       placeholder="حداکثر بودجه اجاره"/>


                                <Input type="tel"
                                       name="mobile"
                                       onChange={handleChange}
                                       value={fields.mobile.value}
                                       autoCompleteOff={true}
                                       className={"mt-24 "}
                                       isInvalid={(!isEmpty(fields.mobile.error))}
                                       invalidFeedback={fields.mobile.error}
                                       placeholder="موبایل"/>

                                {
                                    (!isEmpty(captcha.token)) ?
                                        <Captcha
                                            handleChange={(e) => handleChange(e)}
                                            token={captcha.token}
                                            error={captcha.error}
                                            captchaValue={fields.captcha.value}
                                            className="text-right mt-16"
                                        />
                                        : ''
                                }
                            </React.Fragment>
                            :
                            <StatusGit text={result.text} status={result.status}/>
                    }
                </Body>
            </PerfectScrollbar>

            {
                (isEmpty(result.status)) ?
                    <div className={"invest-form-submit-btn-card px-24 px-lg-32 mt-24"}>
                        <ButtonBase buttonRef={submitRef}
                                    onClick={submitInvest}
                                    color="secondary"
                                    block
                                    disabled={submitLoading}
                                    className="">
                            {
                                (submitLoading) ?
                                    <CircleLoading width={24} height={24}/>
                                    :
                                    'ثبت درخواست'
                            }
                        </ButtonBase>
                    </div>
                    : ''
            }
        </div>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return (prevProps.show === nextProps.show && prevProps.city_id === nextProps.city_id);
}

export default React.memo(InvestmentForm, propsAreEqual);

// styles

const Body = styled.div`
  //overflow-y: auto;
  max-height: calc(100vh - 20rem) !important;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    max-height: calc(100vh - 14rem) !important;
  }

  ${RadioBox} {
    flex-grow: 1;

    &:first-child {
      ${RadioLabel} {
        border-radius: 0 8px 8px 0;
      }
    }

    &:last-child {
      ${RadioLabel} {
        border-radius: 8px 0 0 8px;
      }
    }
  }
`;

const SelectionBox = styled.div`
  .selection-toggle {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  ${SelectionDropdown} {
    position: fixed;
    display: none;
    flex-direction: column;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border-radius: 24px;
    z-index: 5010;

    &.show-dropdown {
      display: flex;
    }

    ${SelectionDropdownHeader} {
      display: flex;
    }
  }
`;